import { Component} from '@angular/core';

@Component({
    selector: 'honor-type-main',
    templateUrl: './honor-type-main.tmpl.html'
})

export class HonorTypeMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  